import { Pipe, PipeTransform } from '@angular/core';
import { Note } from '../../classes/note';

function matchesDateFilter(value: Date | string | null | undefined, filterValue: string): boolean {
    if (!value) {
        return false;
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
        return false;
    }
    const pad = (n: number) => n.toString().padStart(2, '0');
    const formatted = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    return formatted.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;
}

@Pipe({
    name: 'noteCreationDateFilter',
    pure: false
})
export class NoteCreationDateFilterPipe implements PipeTransform {

    transform(noteList: Array<Note>, filterValue: string): Array<Note> {
        if (!noteList || !filterValue) {
            return noteList;
        }
        return noteList.filter(note => matchesDateFilter(note.CreationDate, filterValue));
    }

}
